import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function NotificationBell({ dark = false, to = "/app/whats-new" }) {
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const openItem = async (it) => {
    await api.post("/notifications/read", { announcement_id: it.id });
    setOpen(false); load(); navigate(to);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          className="relative w-9 h-9 rounded-full flex items-center justify-center transition-colors text-foreground/70 hover:bg-secondary/60 hover:text-foreground"
          data-testid="notification-bell">
          <Bell className="w-5 h-5" />
          {data.unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-semibold flex items-center justify-center kp-pop" data-testid="notification-count">
              {data.unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0 overflow-hidden">
        <div className="flex items-center justify-between px-3.5 py-2.5 border-b border-border bg-secondary/30">
          <span className="text-[11px] font-mono uppercase tracking-[0.22em] text-muted-foreground">Notifications</span>
          {data.unread > 0 && <button onClick={markAll} className="text-xs text-primary font-semibold kp-link" data-testid="mark-all-read">Mark all read</button>}
        </div>
        <div className="max-h-80 overflow-y-auto kp-scroll">
          {data.items.length === 0 && <p className="text-sm text-muted-foreground text-center py-10 italic">No updates</p>}
          {data.items.map((it) => (
            <button key={it.id} onClick={() => openItem(it)} data-testid={`notification-item-${it.id}`}
              className={`w-full text-left px-3.5 py-3 hover:bg-secondary/40 border-b border-border/50 flex gap-2 transition ${it.read ? "" : "bg-secondary/30"}`}>
              {!it.read && <span className="w-2 h-2 rounded-full bg-primary mt-1.5 shrink-0" />}
              <span className={it.read ? "pl-4" : ""}>
                <span className="block text-sm font-semibold text-foreground">{it.title}</span>
                <span className="block text-[11px] font-mono text-muted-foreground mt-0.5">{it.tag} · {it.date}</span>
              </span>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
